import {ColumnId, IColumnItem} from "@ui/tableCustom/types/columns";
import {HeadColumns} from "@ui/tableCustom/types/table";
import {
    filterColumns,
    filterHeadColumns,
    getColumnKeys
} from "@containers/export/containers/buildData/helpers/filterColumns";
import {buildExportData} from "@containers/export/containers/buildData/helpers/buildExportData";


export function generate<T>({
                                columnExport,
                                fullColumns,
                                headColumns,
                                data,
                                ignoredExportColumnKey,
                                order,
                                direction,
                                t,
                                exportFromAllColumns
                            }: {
    columnExport: IColumnItem<T>[],
    fullColumns: IColumnItem<T>[],
    headColumns?: HeadColumns<T>,
    data: T[],
    ignoredExportColumnKey?: string | null,
    order?: keyof T | false,
    direction?: string,
    exportFromAllColumns?: boolean
    t: (key: string) => string
}): {
    data: T[],
    columns: IColumnItem<T>[],
    headColumns: HeadColumns<T>
} {
    if (!columnExport?.length) {
        return {
            data: [],
            columns: [],
            headColumns: [],
        }
    }
    const keys: ColumnId<T>[] = getColumnKeys({
        columns: columnExport,
        ignoredExportColumnKey
    })

    const columnsWidthFilters = filterColumns({
        columns: fullColumns,
        keys,
        exportFromAllColumns
    })
    const headColumnsWidthFilters = filterHeadColumns({
        headColumns,
        keys,
        exportFromAllColumns
    })

    return {
        data: buildExportData<T>({
            data,
            order,
            direction,
            keys,
            t,
        }),
        columns: columnsWidthFilters,
        headColumns: headColumnsWidthFilters,
    }
}

